<dx-popup
  title="Traitement de masse"
  (onHiding)="closeDialog"
  [width]="800"
  [height]="'auto'"
  [maxHeight]="800"
  [(visible)]="displayDialog">

  <div class="dialog-line">
    <div class="label" title="DateLivraison">Date de livraison</div>
    <div class="value">
      <dx-date-box #datebox id="dateLiv"
                   [value]="dateLiv"
                   type="date"
                   [displayFormat]="'dd/MM/yyyy'"
                   [calendarOptions]="{ cellTemplate: 'dayCellTemplate', firstDayOfWeek: 1}"
                   (onValueChanged)="onUpdateDateLiv($event)"
                   [disabledDates]="disabledDates"
      >
        <div *dxTemplate="let data of 'dayCellTemplate'">
          <div *ngIf="this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)" class="disabled-day-fermeture-ponctuelle"
               title="Fermeture ponctuelle de la cuisine">
            {{ data.text }}
          </div>
          <div *ngIf="!this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)">
            {{ data.text }}
          </div>
        </div>
      </dx-date-box>
    </div>
  </div>
  <div class="dialog-line">
    <div class="label" title="DateApprovisionnement">Date Approvisionnement</div>
    <div class="value">
      <dx-date-box id="dateAppro"
                   [value]="dateAppro"
                   type="date"
                   [displayFormat]="'dd/MM/yyyy'"
                   (onValueChanged)="onUpdateDateAppro($event)"
      ></dx-date-box>
    </div>
  </div>

  <div class="dialog-line">
    <div class="label" title="BesoinAjuste">Besoin ajusté</div>
    <div class="value">
      <dx-number-box [(value)]="besoinAjuste"></dx-number-box>
    </div>
  </div>

  <!--FOOTER-->
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button iconClass="fas fa-check"
        [theme]="ButtonThemeEnum.SAVE"
                 class="mg-r-5"
                 [disabled]="isDisabledSaveBtn()"
                 (onClick)="sendBulkBesoinSupplier()"></yo-button>
      <yo-button iconClass="fas fa-times"
        [theme]="ButtonThemeEnum.CANCEL" (onClick)="closeDialog()"></yo-button>
    </div>
  </div>
</dx-popup>
